import boardAPI from "@/api/boardAPI";


// state
const state = {
    boardList: [],
    isLast: true,
    page: 0,
    board: {
        title: ''
    },
}

// mutations
const mutations = {
    setBoard(state, {board}) {
        state.board = board
        return state.board
    },
    setBoardList(state, {boardList}) {
        state.boardList = boardList
        return state.boardList
    },
    fetchBoardList(state, {boardList}) {
        state.boardList = [...state.boardList, ...boardList]
        return state.boardList
    },
    fetchIsLast(state, {isLast}) {
        state.isLast = isLast
        return state.isLast
    },
    fetchPage(state, {page}) {
        state.page = page
        return state.page
    },
}

// actions
const actions = {
    async initBoard({commit}, {type, id}) {
        try {
            const {data: {value}} = await boardAPI.getBoardByType(type, id);
            commit('setBoard', {board: value})
            return value
        } catch (e) {
            commit('setBoard', {board: null})
            throw e
        }
    },
    async fetchWebMagazine({commit}, {type, year, month}) {
        try {
            const {data: {value}} = await boardAPI.getWebMagazine(type, year, month);
            commit('setBoard', {board: value})
            return value
        } catch (e) {
            commit('setBoard', {board: null})
            return null
        }
    },
    async initBoardList({commit}, {query, type}) {
        try {
            const {data: {value: {content, last, number}}} = await boardAPI.getBoardListByType(query, type);
            commit('setBoardList', {boardList: content})
            commit('fetchIsLast', {isLast: last})
            commit('fetchPage', {page: number})
            return {
                boardList: state.boardList,
                isLast: state.isLast,
            }
        } catch (e) {
            commit('fetchBoard', {boardList: null})
            throw e
        }
    },
    async fetchBoardList({commit}, {query, type}) {
        try {
            const {data: {value: {content, last, number}}} = await boardAPI.getBoardListByType(query, type);
            commit('fetchBoardList', {boardList: content})
            commit('fetchIsLast', {isLast: last})
            commit('fetchPage', {page: number})
            return {
                boardList: state.boardList,
                isLast: state.isLast,
            }
        } catch (e) {
            commit('fetchBoard', {boardList: null})
            throw e
        }
    },
}

// getters
const getters = {
    getBoard(state) {
        return state.boardList
    },
    isLast(state) {
        return state.isLast
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
